import { DateTime } from 'luxon';
import { useApi } from '../../api/api-context';
import { useQueryMutation } from '../../api/use-query-mutation';
import { useBudgetId } from '../../budget/budget-store';
import { calculateNextDate } from '../recurring-transaction-utils';
import { useGetUserApi } from '../../user/api/use-get-user';
export const useCreateRecurringTransactionApi = (options) => {
    const api = useApi();
    const budgetId = useBudgetId();
    const { data: user } = useGetUserApi();
    const queryKey = ['recurring-transactions', budgetId];
    // api call
    const createRecurringTransactionApi = async (data) => {
        await api.post('/recurring-transaction', data);
    };
    // optimistic update
    const onMutate = (oldData, request) => {
        const newTransactions = oldData ? [...oldData] : [];
        const transactionId = request.id;
        // Recalculate the nextDate based on startDate and frequency
        const startDate = request.startDate;
        const frequency = request.frequency;
        const nextDate = calculateNextDate(DateTime.fromISO(startDate), frequency, user?.timeZone || 'UTC');
        const newTransaction = { ...request, id: transactionId, nextDate: nextDate || '' };
        newTransactions.push(newTransaction);
        return newTransactions;
    };
    return useQueryMutation(createRecurringTransactionApi, queryKey, onMutate, options);
};
